import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AsyncJobsProgressDisplayComponent } from './async-jobs-progress-display.component';

@NgModule({
  imports: [CommonModule, AsyncJobsProgressDisplayComponent],
  exports: [AsyncJobsProgressDisplayComponent],
})
export class AsyncJobsProgressDisplayModule {}
